// Modulos
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

// Componentes
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { FieldRequiredComponent } from './field-required/field-required.component';
import { AvatarModule } from 'ngx-avatar';
import { PdfImageViewerComponent } from './pdf-image-viewer/pdf-image-viewer.component';
import { TooltipLabelComponent } from './tooltip-label/tooltip-label.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MaterialModule } from '@shared/modules/material.module';
import { I18nModule } from '@shared/modules/i18n.module';
import { LoadingPageComponent } from './loading-page/loading-page.component';
import { AlertMessagesComponent } from './alert-messages/alert-messages.component';
import { SimpleMaskModule } from 'ngx-ion-simple-mask';
import { BlockScreenComponent } from './block-screen/block-screen.component';
import { ImageViewerModule } from '@emazv72/ngx-imageviewer';

const avatarColors = ['​#1abc9c', '#2c3e50', '#95a5a6', '#f39c12', '#1abc9c'];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    LoadingPageComponent,
    SidebarComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    FooterComponent,
    FieldRequiredComponent,
    TooltipLabelComponent,
    PdfImageViewerComponent,
    AlertMessagesComponent,
    BlockScreenComponent,
  ],
  imports: [
    ImageViewerModule,
    TooltipModule,
    CommonModule,
    IonicModule,
    RouterModule,
    MaterialModule,
    SimpleMaskModule,
    I18nModule,
    AvatarModule.forRoot({
      colors: avatarColors,
    }),
  ],
  exports: [
    LoadingPageComponent,
    SidebarComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    FooterComponent,
    FieldRequiredComponent,
    TooltipLabelComponent,
    PdfImageViewerComponent,
    AlertMessagesComponent,
    BlockScreenComponent,
  ],
})
export class SharedComponentsModule {}
